import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { ClickEventType } from '@takectrl-multiapp/svcs-share-config';
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private readonly zone: NgZone,
    private readonly navCtrl: NavController,
    public router: Router,
    private location: Location
  ) {}

  async navigatePageForward(page: string, params?: any, event?: KeyboardEvent, click_type?: ClickEventType) {
    if (page) {
      if (click_type === 'auxclick') {
        let url = `/${page}?${params ? new URLSearchParams(params).toString() :''}`;
        window.open(url, '_blank');
      } else if (event && event.ctrlKey || event && event.metaKey) {
        let url = `/${page}?${params ? new URLSearchParams(params).toString() :''}`;
        window.open(url, '_blank');
      } else {
        this.zone.run(async () => {
          this.navCtrl.navigateForward([page], { queryParams: params });
        });
      }
    }
  }

  async navigatePageRoot(page: string, params?: any, event?: any, click_type?: ClickEventType,) {
    if (page) {
      if (click_type === 'auxclick') {
        let url = `/${page}?${params ? new URLSearchParams(params).toString() :''}`;
        window.open(url, '_blank');
      } else if (event && event.ctrlKey || event && event.metaKey) {
          let url = `/${page}?${params ? new URLSearchParams(params).toString() :''}`;
          window.open(url, '_blank');
      } else {
        this.zone.run(async () => {
          this.navCtrl.navigateRoot([page], { queryParams: params });
        });
      }
    }
  }

  navigatePageBack(page: string, params?: any) {
    this.zone.run(async () => {
      this.navCtrl.navigateBack([page], { queryParams: params });
    });
  }

  navigatePopBack() {
    this.location.back();
  }
  
}
